import React from "react";
import { Box, Typography } from "@mui/material";
import { AiEdgeImages } from "../../assets/img/aiedge/AiEdgeImages";
import { getImageUrl } from "../../shared/utils/getImageUrl";

const BottomSection = ({ bottomData }) => {
    return (
        <Box
            sx={{
                position: "relative",
                width: "100%",
                overflow: "hidden",
                display: "inline-block",
            }}
        >
            {/* Background Image with opacity */}
            <Box
                component="img"
                // src={AiEdgeImages.FatherSonImage}
                src={getImageUrl(bottomData?.imageUrl)}
                alt="Father Carrying Son"
                sx={{
                    width: "40%",
                    height: "auto",    // image full height
                    objectFit: "cover",
                    opacity: 0.1,
                    display: "block",
                    margin: "auto"
                }}
            />

            {/* Centered Text */}
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 2,
                    width: { xs: "100%", sm: "100%", md: "70%" },
                    textAlign: "center",
                    px: 2,
                }}
            >
                <Typography
                    variant="h6"
                    dangerouslySetInnerHTML={{ __html: bottomData?.description }}

                />

                {/* A fully personalized, NCERT-aligned, concept-based academic program that understands your child and builds complete learning—step by step, the right way
                </Typography> */}
            </Box>
        </Box>
    );
};

export default BottomSection;


